import { RosterSizeMap } from '../../domain/Roster/RosterSizeMap';
import { loadDocument$ } from './canvas';

export function loadCanvasDocument$ (canvasId: string, docId: string, sessionId?: string) {
  return loadDocument$(canvasId, docId, sessionId)
  .then(function (loadedDoc) {
    const rosterSizeMap = getRosterSizeMap(loadedDoc);
    const rosterSizeOptions = getRosterSizeOptions(loadedDoc);

    return Cx.resolve({
      canvasId,
      docId,
      rosterSizeMap,
      rosterSizeOptions
    });
  });
}

function getRosterSizeMap (doc: Cx.Document): RosterSizeMap[] {
  // @ts-ignore
  const options: RosterSizeMap[] = doc.pages.map((page) => {
    const name = page.name;
    const split = name.split('-');
    const item: RosterSizeMap = {
      OriginalDocPageName: name,
      Size: split[0]
    };

    return item;
  }).filter((option: RosterSizeMap) => {
    return (option.OriginalDocPageName.toLowerCase() !== 'base') ? true : false;
  });

  return options;
}

function getRosterSizeOptions (doc: Cx.Document): string[] {
  // @ts-ignore
  return doc.pages.map((page) => {
    const split = page.name.split('-');
    if (split[0].includes('MULTIMAT') && split[1]) 
      return split[0] + '-' + split[1];
    else  
      return split[0];
  }).filter((size) => {
    return (size && size.toLowerCase() !== 'base') ? true : false;
  });
}


